import module from '../store/product';
import VueObserveVisibility from 'vue-observe-visibility';
import Vue from 'vue';

const plugin = {
    getProductRouteConfig(product) {
        if (product && product.id) {
            if (
                Vue.$router.currentRoute.params.merchantUrl &&
                Vue.$router.currentRoute.params.merchantUrl !== 'search'
            ) {
                return {
                    name: 'merchant-product',
                    params: {
                        id:
                            Vue.$store.getters['Product/getProductAttributeByLanguage'](product, 'product.url') ||
                            product.id,
                        merchantUrl: Vue.$router.currentRoute.params.merchantUrl,
                    },
                };
            }
            if (Vue.$store.getters['Product/getProductAttributeByLanguage'](product, 'product.url')) {
                return {
                    path: `/${Vue.$store.getters['Product/getProductAttributeByLanguage'](product, 'product.url')}`,
                };
            }
            return {
                name: 'product',
                params: {
                    id: product.id,
                },
            };
        }
    },
};

export default {
    install(Vue) {
        Vue.use(VueObserveVisibility);
        if (!Vue.$store.state['Product']) {
            Vue.$store.registerModule('Product', module);
        }

        Vue.prototype.$product = plugin;
        Vue.$product = plugin;
    },
};
